const initFeaturedProducts = (): void => {
  const featuredProductsEls = document.querySelectorAll<HTMLDivElement>('[data-featured-products]');
  if (!featuredProductsEls.length) return;

  const toggleContent = (tabEls: HTMLButtonElement[], currentTab: HTMLButtonElement, currentTabIndex: number, contentEls: HTMLDivElement[]): void => {
    tabEls.forEach((tab): void => tab.classList.remove('fp-tab-btn-active'));
    currentTab.classList.add('fp-tab-btn-active');
    contentEls.forEach((content): void => content.classList.add('hidden'));
    contentEls[currentTabIndex].classList.remove('hidden');
  };

  featuredProductsEls.forEach((section): void => {
    const tabEls = Array.from(section.querySelectorAll<HTMLButtonElement>('[data-featured-products-tab]'));
    const contentEls = Array.from(section.querySelectorAll<HTMLDivElement>('[data-featured-products-content]'));
    if (!tabEls.length || !contentEls.length) return;

    tabEls.forEach((tab, index): void => {
      tab.addEventListener('click', (): void => {
        toggleContent(tabEls, tab, index, contentEls);
      });
    });
  });
};

export default initFeaturedProducts;
